import { ROLE_OVERVIEW_APPS_BY_ROLE } from './RoleOverviewScreen.constants'
import {
  RoleOverviewApp,
  RoleOverviewAppKey,
  RoleOverviewRole,
  RoleOverviewSourceItem
} from './RoleOverviewScreen.types'

const getItemIdentity = (item: RoleOverviewSourceItem): string =>
  item.category ? `category:${item.category}` : `item:${item.translationKey}`

export const mergeRoleOverviewItems = (
  existingItems: RoleOverviewSourceItem[],
  candidateItems: RoleOverviewSourceItem[]
): void => {
  candidateItems.forEach(candidate => {
    const identity = getItemIdentity(candidate)
    const existingIndex = existingItems.findIndex(
      item => getItemIdentity(item) === identity
    )

    if (existingIndex === -1) {
      existingItems.push(candidate)
      return
    }

    const existingPriority = existingItems[existingIndex].priority
    const candidatePriority = candidate.priority
    const bothHavePriority =
      typeof existingPriority === 'number' &&
      typeof candidatePriority === 'number'

    if (bothHavePriority && candidatePriority > existingPriority) {
      existingItems[existingIndex] = candidate
    }
  })
}

export const combineRoleApps = (
  roles: RoleOverviewRole[]
): RoleOverviewApp[] => {
  const apps = new Map<RoleOverviewAppKey, RoleOverviewApp>()

  roles.forEach(role => {
    ROLE_OVERVIEW_APPS_BY_ROLE[role].forEach(sourceApp => {
      const existingApp = apps.get(sourceApp.key)

      if (!existingApp) {
        apps.set(sourceApp.key, {
          key: sourceApp.key,
          items: [...sourceApp.items]
        })
        return
      }

      mergeRoleOverviewItems(existingApp.items, sourceApp.items)
    })
  })

  return Array.from(apps.values())
}

export const getGreetingKey = (
  hour: number
): 'morning' | 'afternoon' | 'evening' => {
  if (hour < 12) return 'morning'
  if (hour < 18) return 'afternoon'
  return 'evening'
}
